import { useCallback } from 'react';
import { NEWS_BASE_URL } from 'services/news/configs';
import { ICreateNewsData } from 'services/news/types';
import { useMutateCaseNewsDetail } from 'services/news/useGetNewsDetail';
import { axiosInstance } from 'services/utils';

export interface IUpdateNewsData extends Partial<ICreateNewsData> {
  newsId: string;
}

const useUpdateNews = () => {
  const mutateCaseNewsDetail = useMutateCaseNewsDetail();

  return useCallback(
    async (data: IUpdateNewsData) => {
      const formData = new FormData();
      for (const key of Object.keys(data)) {
        if (key !== 'newsCoverImage' && key !== 'status') {
          formData.append(key, data[key as keyof IUpdateNewsData] as string);
        }
        if (key === 'newsCoverImage') formData.append(key, data[key as keyof IUpdateNewsData] as File);
        if (key === 'status') formData.append(key, String(data[key]));
      }

      const response = await axiosInstance.patch(`${NEWS_BASE_URL}/update`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      mutateCaseNewsDetail();

      return response;
    },
    [mutateCaseNewsDetail]
  );
};

export default useUpdateNews;
